import { useSyncExternalStore } from 'react';
import { PAYMENT_CURRENCY_CHANGED_EVENT, readCurrencySettings, readPaymentCurrency, getUsdToKhrRate } from '../utils/paymentCurrency';

const subscribe = (listener) => {
  window.addEventListener(PAYMENT_CURRENCY_CHANGED_EVENT, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(PAYMENT_CURRENCY_CHANGED_EVENT, listener);
    window.removeEventListener('storage', listener);
  };
};
const getSnapshot = () => JSON.stringify({
  ...readCurrencySettings(), currency: readPaymentCurrency(),
  // A rate-only change must also re-render KHR prices.
  rate: getUsdToKhrRate(),
});

export default function useStorefrontCurrencies() {
  return JSON.parse(useSyncExternalStore(subscribe, getSnapshot, getSnapshot));
}
